
import React, { useId, useRef } from 'react';

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import ScrollTrigger from 'gsap/ScrollTrigger';

const DashedDrawedSvg = (
  {
    d = 'M584.771 5.47075C653.151 21.7029 812.192 216.138 509.925 148.315C238.253 87.3561 577.569 289.007 1.00676 276.649',
    strokeDasharray = 1940,
    maskStrokDashArrayc = '20 20',
    svgWidth = '283',
    svgHeight = '230.288',
    transformSvg,
    trigger,
    startTrigger = "",
    endTrigger,
    strokeWidth = 12,
    diffrentTriggerEnd = null,
    markers = false,
    scroller = null
  }) => {

  const id = useId().replaceAll(':', '');
  const svgRef = useRef();

  const maskStyle = {
    fill: 'none', stroke: 'var(--site-primary-bg)', strokeWidth: strokeWidth, strokeDasharray: maskStrokDashArrayc,
  }

  const pathesStyle = {
    fill: 'none',
    stroke: 'var(--purple)',
    strokeWidth: strokeWidth - (0.45 * strokeWidth),
    strokeDasharray: strokeDasharray,
    strokeDashoffset: strokeDasharray,
  }

  useGSAP(() => {
    gsap.to(
      svgRef.current,
      {
        strokeDashoffset: 0,
        scrollTrigger: {
          markers: markers,
          trigger: trigger,
          start: startTrigger,
          end: endTrigger,
          scrub: 1,
          ...(diffrentTriggerEnd && { endTrigger: diffrentTriggerEnd }),
          ...(scroller && { scroller: scroller }),
        },
        // ease: 'none',
      },

    );

    setTimeout(() => {

      // Ensure ScrollTrigger recalculates positions
      ScrollTrigger.refresh();
    }, 1000);

  }, []);
  return (
    <svg className="c-dashed-line" width={svgWidth} height={svgHeight}
      style={{ overflow: 'visible', width: `calc(var(--vw) * ${svgWidth}px`, ...(transformSvg && { transform: transformSvg, transformBox: 'stroke-box', overflow: 'visible' }) }}
      viewBox={`0 0 ${svgWidth} ${svgHeight}`} xmlns="http://www.w3.org/2000/svg">
      <defs><path id={`c-dashed-line-${id}`} d={d} /></defs>
      <use style={pathesStyle} xlinkHref={`#c-dashed-line-${id}`} ref={svgRef} />
      <use style={maskStyle} xlinkHref={`#c-dashed-line-${id}`} className="c-dashed-line-in-bg-color" />
    </svg>
  );
}
export default DashedDrawedSvg;
